import { call, put, select } from 'redux-saga/effects';

import Config from 'Config';
import { I18n } from 'Locales';
import { APP_MODES } from 'Constants';
import { Types as FlowTypes } from 'Reducers/flow';
import { Types as GrowlTypes } from 'Reducers/growl';
import { Types as ResultTypes } from 'Reducers/result';
import { Types as CampaignTypes } from 'Reducers/campaign';
import { Types as TransientTypes } from 'Reducers/transient';
import { Types as ApplicationTypes } from 'Reducers/application';
import { offlineResults as offlineResultsSelector } from 'Selectors';
import { Types as CheckInTypes, checkedInPostCodes as checkedInPostCodesSelector } from 'Reducers/checkIn';
import {
  isOffline as isOfflineSelector,
  lastKnownAvatar as lastKnownAvatarSelect,
  lastKnownEmail as lastKnownEmailSelect,
  lastTransaction as lastTransactionSelector,
  mode as modeSelector,
  offlineSince as offlineSinceSelector,
  session as sessionSelector,
  warnedSecurityLogout as warnedSecurityLogoutSelector
} from 'Reducers/application';

import { onOnline } from './onOnline';

const warnSecurityLogout = function* () {
  const currentLocalTime = Date.now();
  const offlineSince = yield select(offlineSinceSelector);

  if (Math.abs(currentLocalTime - offlineSince) > Config.WARN_THRESHOLD) {
    yield put({
      type: ApplicationTypes.UPDATE_PROP,
      key: 'warnedSecurityLogout',
      value: true
    });

    yield put({
      type: GrowlTypes.ALERT,
      title: I18n.t('growl:warn.securityLogout.title'),
      body: I18n.t('growl:warn.securityLogout.body'),
      persist: true,
      kind: 'error'
    });
  }
  if (Math.abs(currentLocalTime - offlineSince) > Config.LOGOUT_THRESHOLD) {
    yield put({ type: ApplicationTypes.SECURITY_LOGOUT });
  }
};

export const navigateTo = function* ({ params }) {
  const mode = yield select(modeSelector);
  const session = yield select(sessionSelector);
  const isOffline = yield select(isOfflineSelector);
  const offlineSince = yield select(offlineSinceSelector);
  const lastKnownEmail = yield select(lastKnownEmailSelect);
  const offlineResults = yield select(offlineResultsSelector);
  const lastKnownAvatar = yield select(lastKnownAvatarSelect);
  const lastTransaction = yield select(lastTransactionSelector);
  const warnedSecurityLogout = yield select(warnedSecurityLogoutSelector);
  const currentCheckInPostcodes = yield select(checkedInPostCodesSelector);

  if (session && !warnedSecurityLogout && isOffline && offlineSince) {
    yield call(warnSecurityLogout);
  }

  const { ba, client, flowId, isDonor, lastTransId, name, orID, primaryLogo } = params;

  switch (name) {
    case 'Login':
      if (isDonor && orID && client && ba) {
        yield put({
          type: TransientTypes.UPDATE_PROPS,
          props: {
            ba,
            badge_number: '',
            client,
            enableDonorLogin: false,
            isDonor,
            orID,
            primaryLogo
          }
        });
        yield put({
          type: ApplicationTypes.UPDATE_PROPS,
          props: {
            mode: APP_MODES.DONOR,
            ba,
            client,
            orID
          }
        });
      } else {
        yield put({
          type: ApplicationTypes.UPDATE_PROP,
          key: 'mode',
          value: APP_MODES.AGENT
        });

        yield put({
          type: TransientTypes.UPDATE_PROPS,
          props: {
            avatar: lastKnownAvatar,
            email: lastKnownEmail,
            email_has_error: false,
            enableAgentLogin: false,
            password: '',
            lastTransaction: { ...lastTransaction, submittedByBa: false }
          }
        });
      }

      break;
    case 'Campaigns':
      yield put({ type: CampaignTypes.GET });
      if (!currentCheckInPostcodes?.length) {
        yield put({ type: CheckInTypes.GET });
      }
      if (!isOffline && offlineResults?.length) {
        onOnline();
      }
      yield put({
        type: ApplicationTypes.UPDATE_PROP,
        key: 'selectedAppBottomBarSection',
        value: { label: 'Home' }
      });
      break;
    case 'Flow':
      if (isOffline || mode === APP_MODES.DONOR) yield put({ type: FlowTypes.INIT_FLOW_METADATA, id: flowId });
      break;
    case 'Reports':
      if (!isOffline) yield put({ type: ResultTypes.GET });

      break;
    case 'ThankYou':
      yield put({
        type: ApplicationTypes.UPDATE_PROPS,
        props: { lastTransaction: { ...lastTransaction, id: lastTransId } }
      });
  }
};
